import { Generic } from "./generic";

export class Lenguaje extends Generic {
    id?: number;
    descripcion?: string;
    lang?: string;
    translate? :string;
    predeterminado?: boolean;
    estado?: boolean;
}